import { useEffect, useState } from "react";
import { FiMaximize2 } from "react-icons/fi";
import { useTranslation } from "react-i18next";

import "../settings.css";
import SideBar from "../Components/SideBar/SideBar";
import SegmentedControl from "../../../../../../Components/UI/SegmentedControl/SegmentedControl";
import BoltButton from "../../../../../../Components/UI/Buttons/BoltButton";
import {
  DEFAULT_UNIT_SYSTEM,
  SETTING_KEYS,
  UNIT_SYSTEMS,
  useSaveGeneralSetting,
  useUnitSystem,
} from "../../../../../../hooks/useGeneralSetting";

const DESCRIPTIONS = {
  Imperial: "units.descriptions.imperial",
  Metric: "units.descriptions.metric",
};

function UnitSettings({ active = "3_2" }) {
  const { t } = useTranslation("settings");
  // The value saved stays the English name; only the label is translated.
  const options = UNIT_SYSTEMS.map((unit) => ({
    value: unit,
    label: t(`units.systems.${unit}`, { defaultValue: unit }),
  }));
  const savedUnit = useUnitSystem();
  const { save, saving } = useSaveGeneralSetting();
  const [value, setValue] = useState(savedUnit);

  useEffect(() => {
    setValue(savedUnit);
  }, [savedUnit]);

  const handleSave = () => save(SETTING_KEYS.measurementUnit, value);

  return (
    <div className="parent_wraper">
      <SideBar active={active} />

      <div className="dash_table_wrapper">
        <div className="flex items-center justify-between px-1 mb-6">
          <h2 className="text-lg font-semibold text-ui-text m-0">
            {t("units.title")}
          </h2>
        </div>

        <div className="bg-ui-surface border border-ui-border rounded-xl p-4 max-w-md">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-7 h-7 rounded-lg bg-brand-light flex items-center justify-center shrink-0">
              <FiMaximize2 size={14} className="text-brand" />
            </div>
            <p className="text-sm font-semibold text-ui-text m-0">
              {t("units.defaultUnits")}
            </p>
          </div>

          <label className="block text-xs font-medium text-ui-text-muted mb-1.5">
            {t("units.usedFor")}
          </label>

          <SegmentedControl
            options={options}
            value={value}
            onChange={setValue}
            ariaLabel={t("units.aria")}
            disabled={saving}
          />

          <p className="mt-3 mb-0 text-xs text-ui-text-subtle">
            {t(DESCRIPTIONS[value] ?? DESCRIPTIONS[DEFAULT_UNIT_SYSTEM])}
          </p>

          <div className="mt-4">
            <BoltButton
              label={saving ? t("actions.savingDots") : t("common:actions.save")}
              onClick={handleSave}
              variant="primary"
              size="sm"
              disabled={saving || value === savedUnit}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnitSettings;
